import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { useAuthHeaders } from "../auth/apiClient";

export interface CareGuideAsset {
  asset_type: "care_guide_pdf";
  filename: string | null;
  size_bytes: number;
  updated_at: string | null;
  download_url: string | null;
}

async function fetchJson<T>(path: string, init: RequestInit): Promise<T> {
  const res = await fetch(path, init);
  if (!res.ok) throw new Error(`Failed to fetch ${path}: ${res.status}`);
  return res.json() as Promise<T>;
}

export function useCareGuideAsset() {
  const headers = useAuthHeaders();
  return useQuery({
    queryKey: ["settings", "brand", "care-guide"],
    queryFn: () => fetchJson<CareGuideAsset>("/api/cockpit/settings/brand/care-guide", { headers }),
  });
}

export function useUploadCareGuideAsset() {
  const headers = useAuthHeaders();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => fetchJson<CareGuideAsset>("/api/cockpit/settings/brand/care-guide", {
      method: "PUT",
      headers: {
        ...headers,
        "Content-Type": "application/pdf",
        "X-Filename": file.name,
      },
      body: file,
    }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["settings", "brand", "care-guide"] }),
  });
}
